import Vue from 'vue';
import types from '../mutations/mutation-types';
import api from '../../utils/api';

export default {
  state: {
    history: []
  },
  mutations: {
    [types.CHAT.ADD_MESSAGE](state, { messages, append }) {
      if (append) {
        state.history = [...state.history, ...messages];
      } else {
        state.history = messages;
      }
    },
    [types.CHAT.MODIFY_MESSAGE](state, { update, index }) {
      Vue.set(state.history, index, update);
    }
  },
  actions: {
    async retrieveMessages({ commit }, phoneNumber) {
      commit(types.PROFILE.SET_PROFILE, null);
      try {
        let messages = [];
        let profile = null;

        const userChats = await api.buildRequest(`chat/${phoneNumber}`, 'GET');
        const userScreeningInfo = await api.buildRequest(`/screening/${phoneNumber}`, 'GET');

        const { status, data } = userChats;
        if (status === 200) {
          messages = data.payload ? data.payload.messages : [];
          profile = data.payload.user[0];
          if (!profile.gender) {
            profile.gender = '';
          }
          if (!profile.language) {
            profile.language = '';
          }
          if (!profile.hadkids) {
            profile.hadkids = '';
          }
          if (!profile.married) {
            profile.married = '';
          }
          profile.referrals = data.payload.referrals;
          profile.feedback = data.payload.feedback;
        }
        commit(types.CHAT.ADD_MESSAGE, { messages });
        commit(types.PROFILE.SET_PROFILE, profile);

        const { status: userScreeningStatus, data: userScreeningData } = userScreeningInfo;

        if (status === 200 && userScreeningStatus === 200) {
          profile.screening = userScreeningData.payload.screening;
          commit(types.PROFILE.SET_PROFILE, profile);
        }
      } catch (error) {
        alert(`An error occurred.  ${error}`); // eslint-disable-line
      }
    },
    fireSmsAction(context, details) {
      return api.buildRequest('send', 'POST', null, details);
    },
    addNewMessage({ commit }, message) {
      commit(types.CHAT.ADD_MESSAGE, {
        messages: [message],
        append: true
      });
    },
    modifyMessage({ commit }, details) {
      commit(types.CHAT.MODIFY_MESSAGE, details);
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/chat.js